/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import {
  addOrganizationMember,
  fetchOrganizationMemberships,
  resetAddOrganizationMemberRequest,
} from '../../../../actions/organizations'
import { addOrganizationMemberRequest } from '../../../../reducers/asyncRequests/registry'

import AddMemberButton from './AddMemberButton'

import type { ThunkDispatch, ReduxState } from '@/types/redux'
import type { StateProps, DispatchProps, ConsumerProps } from './types'

const mapStateToProps = (state: ReduxState): StateProps => ({
  addOrganizationMemberRequest: () => addOrganizationMemberRequest(state),
})

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  addOrganizationMembers: ({ userId, organizationId }) =>
    dispatch(addOrganizationMember({ userId, organizationId })),
  fetchOrganizationMembers: (organizationId: string) =>
    dispatch(fetchOrganizationMemberships({ organizationId })),
  resetAddOrganizationMemberRequest: () => dispatch(resetAddOrganizationMemberRequest()),
})

export default connect<StateProps, DispatchProps, ConsumerProps>(
  mapStateToProps,
  mapDispatchToProps,
)(AddMemberButton)
